import * as React from "react";
import * as monaco from "monaco-editor";
import { AutoSizer } from "react-virtualized";
import "./BaseEditor.scss";
const cleanContent = (content) => {
    if (typeof content === "string") {
        return content;
    }
    return "";
};
export class BaseDiffEditor extends React.Component {
    constructor(props) {
        super(props);
        this.decorations = [];
        this.editorRef = React.createRef();
    }
    componentDidMount() {
        const baseConfig = {
            readOnly: true,
            renderSideBySide: false,
            theme: this.props.dark ? "vs-dark" : "vs",
        };
        this.editor = monaco.editor.createDiffEditor(this.editorRef.current, Object.assign({}, baseConfig));
        var originalModel = monaco.editor.createModel(cleanContent(this.props.originalContent), "text/plain");
        var modifiedModel = monaco.editor.createModel(cleanContent(this.props.modifiedContent), "text/plain");
        this.editor.setModel({
            original: originalModel,
            modified: modifiedModel,
        });
    }
    componentDidUpdate() {
        this.editor.layout();
    }
    componentWillUnmount() {
        if (typeof this.editor !== "undefined") {
            this.editor.dispose();
        }
    }
    render() {
        const { height, width } = this.props;
        return React.createElement("div", { ref: this.editorRef, style: { height, width } });
    }
}
export class DiffEditor extends React.Component {
    render() {
        return (React.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
                overflow: "hidden",
            } },
            React.createElement("div", { style: { flex: "1", padding: "10px" } },
                React.createElement(AutoSizer, null, ({ height, width }) => (React.createElement(BaseDiffEditor, Object.assign({ height: height, width: width }, this.props)))))));
    }
}
//# sourceMappingURL=DiffEditor.js.map